export const COMPONENT_NAME = "kyc-documents";
